"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = joinDimensions;

/**
 * One of the things that we lost when we moved off of css-modules was the ability to add dimensions.
 * This function is intended to help fill that gap.
 * It isn't perfect but usually provides what we need.
 *
 * The first param is the operator (+, -, * or /).
 *
 * The remainder of the params are all values that you wish to execute on.
 *
 * The function will attempt to utilize the first unit that it finds in the set of provided dimensions to join.
 * If no unit is provided, it will treat the arguments as plain old numbers.
 * If the units differ between any two values, it will provide a warning and then go forward using the first unit found.
 */
var dimensionRegex = /^(\d*\.?\d*)(\w+)?$/;

function joinDimensions(operator) {
  // if first has unit, use that, otherwise try for second
  var unit;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var result = args.reduce(function (prev, curr, i) {
    var parts = String(curr).match(dimensionRegex);

    if (parts.length) {
      if (parts[2] && unit !== parts[2]) {
        if (!unit) {
          unit = parts[2]; // eslint-disable-line prefer-destructuring
        } else {
          console.warn("Attempting to join dimensions of various types: ".concat(unit, " and ").concat(parts[2])); // eslint-disable-line no-console
        }
      }

      var value = Number(parts[1]);

      switch (operator) {
        case '+':
          return prev + value;

        case '-':
          return i === 0 ? value : prev - value;

        case '*':
          return i === 0 ? value : prev * value;

        case '/':
          return i === 0 ? value : prev / value;

        default:
          return prev + value;
      }
    }

    return prev;
  }, 0);
  return result === 0 || !unit ? result : "".concat(result).concat(unit);
}